import axios from "@/plugins/axios";
import application from "./application";

let url = "/api/v1/recruitments";

export default {
    application,

    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`, data).then((result) => result.data);
    },
};
